<template>
  <div class="multimedia-empty">
    <div class="multimedia-empty__container">
      <component v-bind:is="icon" class="multimedia__content-empty--icon" />
    </div>
    <label class="multimedia-empty__label">{{ $t("multimedia.empty") }}</label>
  </div>
</template>

<script>
import TypeVideoIcon from '@/assets/icons/type-video.svg';
import TypeImageIcon from '@/assets/icons/type-image.svg';
import TypeDocumentIcon from '@/assets/icons/type-document.svg';

export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  components: {
    TypeVideoIcon,
    TypeImageIcon,
    TypeDocumentIcon,
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/components/chat-multimedia-empty.scss";

.multimedia-empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 65px 0px;

  &__container {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--chat-multimedia-empty-container);
    width: 200px;
    height: 200px;
    padding: 10px;
    border-radius: 50%;
    margin-bottom: 20px;
  }

  &__label {
    color: var(--chat-multimedia-empty-label);
    font-weight: bold;
  }
}
</style>
